import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import PackageLayout from 'layout/PackageLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const PackagePage = Loadable(lazy(() => import('views/package-page')));

// ==============================|| MAIN ROUTING ||============================== //

const PackageRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <PackageLayout />
            </AuthGuard>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/w/:workspaceId/p/:projectId/c/:campaignId/pkg/:packageId',
            element: <PackagePage />
        }
    ]
};

export default PackageRoutes;
